import { Tooltip } from "antd";
import React from "react";

import { FilterIcon } from "@/Components/Icons/FilterIcon";
import { TOOLTIPTEXT } from "@/utilities/CommonText";

/**
 * Functional component for the FilterButton.
 *
 * @param {boolean} filterApplied - Indicates if the filter is currently applied
 * @param {function} handleClick - The function to be called when the button is clicked
 * @return {JSX.Element} The FilterButton component
 */
const FilterButton = ({ filterApplied, handleClick }) => {
  return (
    <Tooltip title={TOOLTIPTEXT.filter}>
      <div
        className={`grid h-[40px] w-[56px] min-w-[56px] cursor-pointer place-items-center rounded-lg ${
          filterApplied ? "bg-primary text-white" : "bg-grey text-txtColor"
        } hover:bg-lightblue hover:text-primary`}
        onClick={handleClick}
      >
        <FilterIcon />
      </div>
    </Tooltip>
  );
};

export default FilterButton;
